import React from "react";
import PropTypes from "prop-types";
import { Scope } from "informed";
import {
	ColorPicker,
	NumberInput,
	BorderStylePicker,
	FileInput,
	GradientInput,
	ShadowInput,
} from "../../../../../components/shared/Forms";
import { Font } from ".";

const Buttons = ({ themeData, scopePicked, primaryState, checkForEmptyValues }) => {
	const currentElementType = themeData.buttons[scopePicked];
	const states = Object.keys(currentElementType);
	return (
		<div className="theme-columns">
			{states.map(state => {
				const primaryStatePath = `buttons.${scopePicked}.${primaryState}`;
				const currentStatePath = `buttons.${scopePicked}.${state}`;
				return (
					<Scope scope={state} key={state}>
						<div className="theme-column">
							<h4 className="header">{state}</h4>
							<div className="theme-content">
								<Scope scope="font">
									<Font
										state={state}
										checkForEmptyValues={checkForEmptyValues}
										primaryStatePath={primaryStatePath}
										currentStatePath={currentStatePath}
									/>
								</Scope>
								{checkForEmptyValues(primaryStatePath, currentStatePath, [
									<BorderStylePicker
										field="borderStyle"
										id="borderStyle"
										placeholder="Border Styles"
										themeBuilderInputType="BorderStylePicker"
									/>,
									<ColorPicker
										field="borderColor"
										id="borderColor"
										placeholder="Border Color"
										themeBuilderInputType="ColorPicker"
									/>,
									<NumberInput
										field="borderWidth"
										id="borderWidth"
										placeholder="Border Width"
										themeBuilderInputType="NumberInput"
									/>,
									<NumberInput
										field="borderRadius"
										id="borderRadius"
										placeholder="Border Radius"
										max={768}
										themeBuilderInputType="NumberInput"
									/>,
									<NumberInput
										field="paddingVertical"
										id="paddingVertical"
										placeholder="Vertical Padding"
										themeBuilderInputType="NumberInput"
									/>,
									<NumberInput
										field="paddingHorizontal"
										id="paddingHorizontal"
										placeholder="Horizontal Padding"
										themeBuilderInputType="NumberInput"
									/>,
									<ColorPicker
										field="backgroundColor"
										id="backgroundColor"
										placeholder="Background Color"
										themeBuilderInputType="ColorPicker"
									/>,
									<FileInput
										field="backgroundImageUrl"
										id="backgroundImageUrl"
										placeholder="Background Image"
										themeBuilderInputType="FileInput"
									/>,
									<GradientInput
										field="backgroundGradient"
										id="backgroundGradient"
										placeholder="Background Gradient"
										themeBuilderInputType="GradientInput"
									/>,
									<ShadowInput
										field="boxShadow"
										id="boxShadow"
										placeholder="Box Shadow"
										themeBuilderInputType="ShadowInput"
									/>,
								])}
							</div>
						</div>
					</Scope>
				);
			})}
		</div>
	);
};

Buttons.propTypes = {
	checkForEmptyValues: PropTypes.func.isRequired,
	primaryState: PropTypes.string.isRequired,
	scopePicked: PropTypes.string.isRequired,
	themeData: PropTypes.object.isRequired,
};

export default Buttons;
